import { createHashHistory, createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";

// In the packaged desktop app the bundle is loaded from a `file://…/index.html`
// URL, so pathname-based (browser) history can't match any route and every load
// 404s. Use hash history there (works for `file://`); the browser web app keeps
// clean pathname URLs.
const isFileProtocol =
  typeof window !== "undefined" && window.location.protocol === "file:";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: false,
  ...(isFileProtocol ? { history: createHashHistory() } : {}),
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
